import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { displayField, getRootComponent } from "../../utilities/ElementUtils";
import { spacing } from '../../theme';
import { isNullOrEmpty } from "../../utilities/DataUtils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  hint?: string;
  useAsterisks?: string;
  HideOptionalText?: string;
}


export class OdsDateComponent extends React.Component<Props> {
  year: string = '';
  month: string = '';
  day: string = '';
  private lastSyncedValue: string | null | undefined = undefined;

  constructor(props: Props) {
    super(props);

    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
    this.syncFromField(field.Value);
  }

  setValue = () => {
    if (this.day && this.month && this.year) {
      return this.month + '/' + this.day + '/' + this.year;
    }

    return null;
  }

  normalizeIncomingValue(value: unknown): string | null {
    if (typeof value !== 'string' || isNullOrEmpty(value)) {
      return null;
    }

    if (value.includes("/")) {
      const slashDateMatch = value.trim().match(/^(\d{1,2}\/\d{1,2}\/\d{4})/);
      return slashDateMatch ? slashDateMatch[1] : value;
    }

    const isoDateMatch = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return `${month}/${day}/${year}`;
    }

    return null;
  }

  private getPartialDateInvalidFormat = (): string => {
    const field = this.props.field;
    const month = this.month || field.month || '00';
    const day = this.day || field.day || '00';
    const year = this.year || field.year || '0000';
    return `${month}/${day}/${year}`;
  }

  onODSDateChangeOnDialog = (e, dateFormat) => {
    let field = this.props.field;
    if (field.ReadOnly) {
      e?.preventDefault?.();
      return;
    }
    let val = e.target.value;
    val = val.trim();

    switch (dateFormat) {
      case 'dd':
        this.day = val;
        break;
      case 'mm':
        this.month = val;
        break;
      case 'yyyy':
        this.year = val;
        break;
    }

    const finalDate = this.setValue();

    const hasYear = !isNullOrEmpty(this.year);
    const hasMonth = !isNullOrEmpty(this.month);
    const hasDay = !isNullOrEmpty(this.day);
    const hasAnyValue = hasYear || hasMonth || hasDay;
    const hasAllValues = hasYear && hasMonth && hasDay;
    const isPartialDate = hasAnyValue && !hasAllValues;

    if (hasAnyValue) {
      field.Touched = true;
    }

    field.day = this.day;
    field.month = this.month;
    field.year = this.year;

    if (isNullOrEmpty(finalDate)) {
      if (isPartialDate) {
        field.Value = this.getPartialDateInvalidFormat();
        field.Valid = false;
        field.IsEmpty = false;
        field.Touched = true;
        field.ErrorMessage = isNullOrEmpty(field.ErrorMessage) ? 'Invalid date (please provide full date)' : field.ErrorMessage
        field.ErrorMessageFRA = isNullOrEmpty(field.ErrorMessageFRA) ? 'Date invalide (veuillez fournir la date complète)' : field.ErrorMessageFRA
      } else {
        field.Value = null;
        field.IsEmpty = true;
        field.Valid = true;
      }
    } else {
      if (!FormValidationUtils.isValidDate(finalDate)) {
        field.Value = finalDate;
        field.Valid = false;
        field.IsEmpty = false;
        field.Touched = true;
        field.ErrorMessage =isNullOrEmpty(field.ErrorMessage) ?  'Invalid date (please enter a valid year / month / day)' : field.ErrorMessage
        field.ErrorMessageFRA = isNullOrEmpty(field.ErrorMessageFRA) ? 'Date invalide (veuillez entrer une année / mois / jour valide)' : field.ErrorMessageFRA;
      } else {
        field.Value = finalDate;
        field.IsEmpty = false;
        field.Valid = true;
      }
    }
    this.lastSyncedValue = field.Value;

    this.props.callbackElement(getRootComponent(this.props.field));
  }



  onBlur = (e) => {
    let field = this.props.field;
    
    // Sync component state with field state
    /*if (field.year !== undefined) this.year = field.year || '';
    if (field.month !== undefined) this.month = field.month || '';
    if (field.day !== undefined) this.day = field.day || '';
    
    const hasYear = !isNullOrEmpty(this.year);
    const hasMonth = !isNullOrEmpty(this.month);
    const hasDay = !isNullOrEmpty(this.day);
    const hasAnyValue = hasYear || hasMonth || hasDay;
    const hasAllValues = hasYear && hasMonth && hasDay;
    const isPartialDate = hasAnyValue && !hasAllValues;
    
    if (isPartialDate) {
      field.Value = this.getPartialDateInvalidFormat();
      field.Valid = false;
      field.IsEmpty = false;
      field.Touched = true;
      field.ErrorMessage = isNullOrEmpty(field.ErrorMessage) ? 'Invalid date (please provide full date)' : field.ErrorMessage
      field.ErrorMessageFRA = isNullOrEmpty(field.ErrorMessageFRA) ? 'Date invalide (veuillez fournir la date complète)' : field.ErrorMessageFRA
    }*/
    
    FormValidationUtils.validateODSDate(field);
    FormValidationUtils.runJavascript(field);
    this.props.callbackElement(getRootComponent(this.props.field));
  }

  render() {
    let validateCpmpareField;
    let field = this.props.field;
    const sectionReadOnly = field.parent?.parent?.SectionReadonly === true;
    field.ReadOnly = field.ReadOnly || sectionReadOnly;

    const inputReadOnly = field.ReadOnly;
    if (inputReadOnly && field.Value == null) {
      this.month = '';
      this.day = '';
      this.year = '';
    }

    if (field.Value !== this.lastSyncedValue) {
      this.syncFromField(field.Value);
    }
    let displayfield: boolean = true;
    if (!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    let dateValid: boolean = true;


    if (field.FilterField != null) {
      let filterValue;
      let baseName;
      let bindName;
      let parts = field.FilterField.split('.');
      if (parts.length == 3) {
        baseName = parts[0] + '.' + parts[1];
        bindName = parts[2];
      }
      if (parts.length == 2) {
        baseName = parts[0];
        bindName = parts[1];
      }
      if (parts.length == 1) {
        baseName = '';
        bindName = parts[0];
      }

      let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);

      let foundFilterField;

      if (foundFilterFields && foundFilterFields.length > 0) {
        foundFilterField = foundFilterFields[0];
      }

      if (foundFilterField != null) {
        filterValue = foundFilterField.Value;

        if (filterValue == null || filterValue != null && field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(field.FilterValue) == -1) {
          displayfield = false;
        }
      }
    }

    if (field.ValidateCompareMethod != null) {
      let subSection = field.parent as FormSubSections;
      let foundValidateCpmpareFieldList = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == field.ValidateCompareField);
      if (foundValidateCpmpareFieldList.length > 0) {
        validateCpmpareField = foundValidateCpmpareFieldList[0];
        if (field.ValidateCompareMethod == "<")
          dateValid = field.Value <= validateCpmpareField.Value;
        else if (field.ValidateCompareMethod == ">") {
          dateValid = field.Value >= validateCpmpareField.Value;
        } else {
          dateValid = field.Value == validateCpmpareField.Value;
        }
      }
    }

    displayfield = displayfield && displayField(field);
    if (displayfield) {
      let style: React.CSSProperties | undefined;
      if (field.MarginBottom) {
        const isNegativeMargin = field.MarginBottom.startsWith("-");
        const spacingToken = isNegativeMargin ? field.MarginBottom.substring(1) : field.MarginBottom;
        const spacingKey = spacingToken as keyof typeof spacing;
        const spacingValue = spacing[spacingKey];
        const marginBottomValue = spacingValue
          ? `${isNegativeMargin ? "-" : ""}${spacingValue}`
          : field.MarginBottom;
        style = { marginBottom: marginBottomValue };
      }

      // const isReadOnlyView = !editable || inputReadOnly;
      let hintHtml = this.props.isEng ? field.Hint : field.HintFR;

      if (editable) {
        const yearValue = this.year ?? '';
        const monthValue = this.month ?? '';
        const dayValue = this.day ?? '';
        controlArray.push(
          <fieldset role="group" className="ontario-fieldset ontario-margin-top-24-!" style={style} aria-describedby={field.Valid ? undefined : `${field.LoadBindName}-${field.Id}-error`}>
            <legend className="ontario-fieldset__legend ontario-margin-bottom-0-!" style={field?.fieldSize ? { fontSize: field?.fieldSize } : undefined}>
              {/* {labelControlArray} */}
              {field.Optional !== "Y" && (
                <>
                  {title}
                  <span className="ontario-label__flag">
                    {this.props.useAsterisks == "Y" && <span style={{ color: 'red' }}>*</span>}
                    {this.props.useAsterisks !== "Y" && (
                      <span className='ontario-label__flag'>{this.props.isEng ? "(required)" : "(obligatoire)"}</span>
                    )}
                  </span>
                </>
              )}
              {field.Optional === "Y" && (
                <>
                  {title}
                  <span className="ontario-label__flag">
                    {this.props.HideOptionalText != "Y" && (this.props.isEng ? "(optional)" : "(facultatif)")}
                  </span>
                  {field.enuToolTip && <i title={field.TooltipENU} className="pi pi-info-circle" />}
                </>
              )}
            </legend>
            {this.props.hint && <p className="ontario-hint ontario-margin-top-16-!">{this.props.hint}</p>}
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />

            <div className="ontario-date__group" id={field.LoadBindName}>
              <div className="ontario-date__group-input">
                <label htmlFor={`year-${field.Id}`}>{this.props.isEng ? "Year" : "Année"}<span className="ontario-show-for-sr">(4 digits)</span></label>
                <input
                  className={classNames(
                    "ontario-input",
                    "ontario-input--4-char-width",
                    { "ontario-input__error": this.props.field.Touched && !this.props.field.Valid }
                  )}
                  id={`year-${field.Id}`}
                  name={field.LoadBindName}
                  type="text"
                  key={'fdIpt_year' + field.Id}
                  maxLength={4}
                  value={yearValue}
                  readOnly={inputReadOnly}
                  aria-required={field.Optional !== "Y"}
                  aria-invalid={!field.Valid ? true : undefined}
                  onBlur={this.onBlur}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '');
                    this.onODSDateChangeOnDialog(e, "yyyy");
                    if (e.target.value.length === 4) {
                      const monthInput = document.getElementById(`month-${field.Id}`) as HTMLInputElement | null;
                      monthInput?.focus();
                    }
                  }}
                ></input>
              </div>
              <div className="ontario-date__group-input">
                <label htmlFor={`month-${field.Id}`}>{this.props.isEng ? "Month" : "Mois"}<span className="ontario-show-for-sr">(1 or 2 digits)</span></label>
                <input
                  className={classNames(
                    "ontario-input",
                    "ontario-input--2-char-width",
                    { "ontario-input__error": this.props.field.Touched && !this.props.field.Valid }
                  )}
                  id={`month-${field.Id}`}
                  type="text"
                  key={'fdIpt_month' + field.Id}
                  maxLength={2}
                  max={12}
                  value={monthValue}
                  readOnly={inputReadOnly}
                  aria-required={field.Optional !== "Y"}
                  aria-invalid={!field.Valid ? true : undefined}
                  onBlur={this.onBlur}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '');
                    this.onODSDateChangeOnDialog(e, "mm");
                    if (e.target.value.length === 2) {
                      const dayInput = document.getElementById(`day-${field.Id}`) as HTMLInputElement | null;
                      dayInput?.focus();
                    }
                  }}
                ></input>
              </div>
              <div className="ontario-date__group-input">
                <label htmlFor={`day-${field.Id}`}>{this.props.isEng ? "Day" : "Jour"}<span className="ontario-show-for-sr">(1 or 2 digits)</span></label>
                <input
                  className={classNames(
                    "ontario-input",
                    "ontario-input--2-char-width",
                    { "ontario-input__error": this.props.field.Touched && !this.props.field.Valid }
                  )}
                  id={`day-${field.Id}`}
                  type="text"
                  key={'fdIpt_day' + field.Id}
                  maxLength={2}
                  max={31}
                  value={dayValue}
                  readOnly={inputReadOnly}
                  aria-required={field.Optional !== "Y"}
                  aria-invalid={!field.Valid ? true : undefined}
                  onBlur={this.onBlur}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '');
                    this.onODSDateChangeOnDialog(e, "dd");
                  }}
                ></input>
              </div>
            </div>
          </fieldset>
        );

      } else {
        let date;
        if (field.Value) {
          date = new Date(field.Value).toLocaleDateString();
        }
        if (date == "Invalid Date") {
          date = null;
        }
        controlArray.push(
          <div className='pdf-two-column'>
            <div>{title}</div>
            <div className={classNames({ 'invalid-field--highlighted': field.Valid === false })} >{field.Value ? date : null}</div>
          </div>
        );
      }
    }

    return controlArray;

  }

  private syncFromField(value: unknown) {
    const field = this.props.field;

    if (typeof value === 'string' && !isNullOrEmpty(value)) {
      const normalizedValue = this.normalizeIncomingValue(value) ?? value;
      if (normalizedValue !== value) {
        field.Value = normalizedValue;
      }
      const dateParts = normalizedValue.split("/");
      if (dateParts.length === 3) {
        this.month = dateParts[0];
        this.day = dateParts[1];
        this.year = dateParts[2];
        field.month = dateParts[0];
        field.day = dateParts[1];
        field.year = dateParts[2];
      } else {
        this.month = '';
        this.day = '';
        this.year = '';
        field.month = '';
        field.day = '';
        field.year = '';
      }
      this.lastSyncedValue = normalizedValue;
      return;
    }

    this.month = '';
    this.day = '';
    this.year = '';
    field.month = '';
    field.day = '';
    field.year = '';
    this.lastSyncedValue = value as string | null | undefined;
  }

}
